import React, { memo as Memo, useRef, useEffect, useState, useCallback } from 'react';
import { withRouter } from 'next/router';
import Link from 'next/link';

//* HOCs
import { withLanguageContext } from 'context';

//* Components
import Text from 'components/common/Text';

//* Styles
import LanguageSwitcherStyle from './style';

const LanguageSwitcher = Memo(({ languages, type, ...props }) => {
	//! Refs
	const contRef = useRef();

	//! States
	const [opened, setOpened] = useState(false);

	//! Window Click Listener for close
	const handleWindowClick = useCallback(
		(e) => {
			if (!contRef.current.contains(e.target)) {
				setOpened(false);
			}
		},
		[opened]
	);

	//! Did Mount
	useEffect(() => {
		window.addEventListener('click', handleWindowClick);

		return () => {
			window.removeEventListener('click', handleWindowClick);
		};
	}, []);

	return !(type === 'footer') ? (
		<LanguageSwitcherStyle className={` ${props.className || ''} ${opened ? 'opened' : ''} language-switcher p pXS`}>
			<Text
				ref={contRef}
				onClick={() => setOpened(!opened)}
				tag='span'
				className='font-ping-bold selected-lang'
				text={languages[props.router.locale]?.params.name}
			/>

			<div className='languages-cont primaryColor3-bg font-helvetica secondaryColor2'>
				{Object.keys(languages)
					.filter((lang) => lang !== props.router.locale)
					.map((lang) => {
						return (
							<Link
								key={lang}
								locale={lang}
								className={`lang-item`}
								href={props.router.asPath}
							>
								{languages[lang].params.name}
							</Link>
						);
					})}
			</div>
		</LanguageSwitcherStyle>
	) : (
		<LanguageSwitcherStyle
			ref={contRef}
			className={` ${props.className || ''} language-switcher`}
		>
			{Object.keys(languages).map((lang) => (
				<Link
					key={lang}
					locale={lang}
					href={props.router.asPath}
					className={`lang-item lang-item-footer ${props.router.locale === lang ? 'active' : ''}`}
				>
					{languages[lang].params?.name}
				</Link>
			))}
		</LanguageSwitcherStyle>
	);
});

export default withRouter(withLanguageContext(LanguageSwitcher, ['languages']));
